import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=4922a73a&"
import script from "./ProfileStats.vue?vue&type=script&lang=ts&"
export * from "./ProfileStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4922a73a')) {
      api.createRecord('4922a73a', component.options)
    } else {
      api.reload('4922a73a', component.options)
    }
    module.hot.accept("./ProfileStats.vue?vue&type=template&id=4922a73a&", function () {
      api.rerender('4922a73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ProfileStats.vue"
export default component.exports